
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer",
      function () {
        return require("private-next-pages/developer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer"])
      });
    }
  